$(document).ready(function(){

    if (window.matchMedia("(max-width: 991px)").matches) {  

        /*
        var headerHeight = $('.logoNav').outerHeight();

        $('.js-toggleMenu').on('click',function(e){
            e.preventDefault();

            $(this).toggleClass('is-open');
            $('body').toggleClass('nav-expanded');
        });


        $('.anchorNav a').on('click',function(event){
            $('body').toggleClass('nav-expanded');
        });

        //Sottomenu
        $('.has-submenu>a').on('click',function(event){
            event.preventDefault();
            $(this).siblings('.submenu').slideToggle('slow');
            $(this).parent().toggleClass('is-selected');
        });
        */


        $(".nav-expander").on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("nav-expanded");
        });
        $("#nav-close").on("click", function (e) {
            e.preventDefault();
            $("body").removeClass("nav-expanded");
        });



    }


    // Sottomenu desktop
    if (window.matchMedia("(min-width: 992px)").matches){

        $('.has-submenu > a').on('click', function(event){
            event.preventDefault();
             
            var selectedItem = $(this).parent('.has-submenu');

            if(!$(selectedItem).hasClass('is-selected')){
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
                selectedItem.addClass('is-selected').children('.submenu').addClass('is-open');
            }
            
            else{
                selectedItem.removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
        });
       
  
      $(document).click(function (e) {
        //check if the clicked area is dropDown or not
          if ($('.has-submenu').has(e.target).length === 0) {
                $('.has-submenu').removeClass('is-selected').children('.submenu').removeClass('is-open');
            }
          
          if ($('.js-dropdown,.js-dropdown > ul').has(e.target).length === 0) {
                $('.js-dropdown > ul').hide();
            }
           
        })
    }



	// Shrinking header
	var addBackground = 5;
	//var addBackground = 10;

	$(window).scroll(function () {
		var scroll = getCurrentScroll();
		if (scroll >= addBackground) {
			$(".home .header").addClass("whiteBg");
			//$('path').attr('fill', '#ccc');
		} else {
			$(".home .header").removeClass("whiteBg");
		}
	});

	function getCurrentScroll() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

   

    // Slick 

    $('.updates-slider').slick({
        infinite: false,
        arrows: true,
        dots: false,
        prevArrow: '.updates .slick-custom-prev',
        nextArrow: '.updates .slick-custom-next',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
    });

    $('.cards-slider').slick({
        infinite: false,
        arrows: false,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
    });

    $('.people-slider').slick({
        infinite: false,
        arrows: true,
        dots: false,
        prevArrow: '.people .slick-custom-prev',
        nextArrow: '.people .slick-custom-next',
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
    });

    $('.showroom-slider').slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        lazyLoad: 'ondemand'
    });

    if (window.matchMedia("(max-width: 768px)").matches) {  
        $('.highlights .mobile-slider').slick({
            infinite: false,
            arrows: false,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: false,
        });
    }

    $('.sectionTiles').each(function() {
        var $cta = $(this).find('.morelink');
        if ($cta.length > 0) {
            $(this).find('img, h3, p').css('cursor', 'pointer').click(function() {
                window.location.href = $cta.attr('href');
            });
        }
    });

    // Smooth Anchor scroll with fixed header
    var headerHeight  = $('header').outerHeight();
    $('body').on('click','a[href^="#"]',function(event){
        event.preventDefault();
        var target_offset = $(this.hash).offset() ? $(this.hash).offset().top : 0;
        $('html, body').animate({
            scrollTop: target_offset - headerHeight - 30
        }, 100);
    });
});
